module.exports = __webpack_public_path__ + "img/container-blue.3bbbd4df.svg";